import { render, staticRenderFns } from "./CustomTitle.vue?vue&type=template&id=cd2ad514&scoped=true&"
import script from "./CustomTitle.vue?vue&type=script&lang=js&"
export * from "./CustomTitle.vue?vue&type=script&lang=js&"
import style0 from "./CustomTitle.vue?vue&type=style&index=0&id=cd2ad514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2ad514",
  null
  
)

export default component.exports